interface AlignmentMarkProps {
  className?: string;
}

export function AlignmentMark({ className }: AlignmentMarkProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 5.04148V3.02469C8.33555 3.00836 8.16875 3 8 3C7.83125 3 7.66445 3.00836 7.5 3.02469V5.04148C6.24375 5.25224 5.25224 6.24375 5.04148 7.5H3.02469C3.00836 7.66445 3 7.83125 3 8C3 8.16875 3.00836 8.33555 3.02469 8.5H5.04148C5.25224 9.75625 6.24375 10.7478 7.5 10.9585V12.9753C7.66445 12.9916 7.83125 13 8 13C8.16875 13 8.33555 12.9916 8.5 12.9753V10.9585C9.75625 10.7478 10.7478 9.75625 10.9585 8.5H12.9753C12.9916 8.33555 13 8.16875 13 8C13 7.83125 12.9916 7.66445 12.9753 7.5H10.9585C10.7478 6.24375 9.75625 5.25224 8.5 5.04148ZM8.5 7.5H10.9585C10.9858 7.6626 11 7.82964 11 8C11 8.17036 10.9858 8.3374 10.9585 8.5H8.5V7.5ZM8.5 7.5L7.5 7.5V5.04148C7.6626 5.0142 7.82964 5 8 5C8.17036 5 8.3374 5.0142 8.5 5.04148V7.5ZM8.5 8.5V10.9585C8.3374 10.9858 8.17036 11 8 11C7.82964 11 7.6626 10.9858 7.5 10.9585V8.5L8.5 8.5ZM7.5 8.5H5.04148C5.0142 8.33739 5 8.17036 5 8C5 7.82964 5.0142 7.6626 5.04148 7.5H7.5V8.5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 0H7.5V2.02054C4.5851 2.26101 2.26101 4.5851 2.02054 7.5H0V8.5H2.02054C2.26101 11.4149 4.5851 13.739 7.5 13.9795V16H8.5V13.9795C11.4149 13.739 13.739 11.4149 13.9795 8.5H16V7.5H13.9795C13.739 4.5851 11.4149 2.26101 8.5 2.02054V0ZM8.5 3.02469V2.02054C8.33513 2.00694 8.16838 2 8 2C7.83162 2 7.66487 2.00694 7.5 2.02054V3.02469C5.13779 3.25922 3.25922 5.13779 3.02469 7.5H2.02054C2.00694 7.66487 2 7.83162 2 8C2 8.16838 2.00694 8.33513 2.02054 8.5H3.02469C3.25922 10.8622 5.13779 12.7408 7.5 12.9753V13.9795C7.66487 13.9931 7.83162 14 8 14C8.16838 14 8.33513 13.9931 8.5 13.9795V12.9753C10.8622 12.7408 12.7408 10.8622 12.9753 8.5H13.9795C13.9931 8.33513 14 8.16838 14 8C14 7.83162 13.9931 7.66487 13.9795 7.5H12.9753C12.7408 5.13779 10.8622 3.25922 8.5 3.02469Z"
      />
    </svg>
  );
}
